import React from 'react'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from 'helpers/globals'
import tippy from 'tippy.js'

class WarningIcon extends React.Component {
  componentDidMount = _ => tippy(this.refs.tooltipContainer, { duration: 0, theme: 'topbar', placement: 'top', onShow: instance => this.tooltip = instance })

  componentWillUnmount = _ => this.tooltip && this.tooltip.hide()

  render() {
    const { title, classes } = this.props

    return (
      <span
        className={classes.icon}
        title={title}
        ref='tooltipContainer'
      >
        <FontAwesomeIcon icon='exclamation-triangle' />
      </span>
    )
  }
}

const style = {
  icon: {
    fontSize: '2rem',
    cursor: 'pointer',
    marginLeft: '1rem',
    color: COLORS.warning
  }
}

export default (injectSheet(style)(WarningIcon))



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ModelDetails/WarningIcon.js